import { Box, FormControl, FormHelperText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { FC } from 'react';

interface DatePickerComponentProps {
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
  label?: string;
  error?: string;
  touched?: boolean;
  isLoading?: boolean;
}

const DatePickerComponent: FC<DatePickerComponentProps> = ({
  value,
  onChange,
  label = 'Selecionar Data',
  error,
  touched,
  isLoading,
}) => {
  return (
    <FormControl fullWidth error={Boolean(error && touched)}>
      <Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            disabled={isLoading}
            label={label}
            value={value}
            onChange={onChange}
            minDate={dayjs()} // Impede datas anteriores a hoje
            format="DD/MM/YYYY" // Formato de data brasileiro
            slotProps={{
              textField: { fullWidth: true, error: Boolean(error && touched) },
            }}
          />
        </LocalizationProvider>
        {touched && error && <FormHelperText>{error}</FormHelperText>}
      </Box>
    </FormControl>
  );
};

export default DatePickerComponent;
